import React from 'react';
import PropTypes from 'prop-types';
import logo from './logo.png';


const Logo = ({ width, height }) => (
  <img width={width} height={height} alt="" src={logo} />
);

const propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

const defaultProps = {
  width: '288px',
  height: '69px',
};

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;

export default Logo;
